export default (theme) => ({
  root: {
    paddingLeft: '100px',
    paddingRight: '100px',
    paddingBottom: '75px',
    flexBasis: '700px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginTop: '100px',
    }
  },
  fields: {
    marginTop: theme.spacing(5)
  },
  textField: {
    width: '100%',
    '& + & ': {
      marginTop: theme.spacing(2)
    }
  },
  remember: {
    display: 'flex',
    alignItems: 'center'
  },
  rememberCheckbox: {
    marginLeft: '-11px'
  },
  rememberText: {
    color: theme.palette.text.secondary,
    display: 'inline'
  },
  signInWrapper: {
    position: 'relative'
  },
  signInButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -4,
    marginLeft: -12
  },
  subText: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2)
  },
  subTextUrl: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  fieldError: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  submitError: {
    color: theme.palette.error.main,
    alignText: 'center',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2)
  }
});
